"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var baseFont = exports.baseFont = "\"Benton Sans\", Arial, sans-serif";
var baseFontCondensed = exports.baseFontCondensed = "\"Benton Sans Condensed\", Arial Narrow, sans-serif"; // 48px

var fontSizeMaximum = exports.fontSizeMaximum = "3rem"; // 40px

var fontSizeXxlarge = exports.fontSizeXxlarge = "2.5rem"; // 28px

var fontSizeXlarge = exports.fontSizeXlarge = "1.75rem"; // 20px

var fontSizeLarge = exports.fontSizeLarge = "1.25rem"; // 16px

var fontSizeDefault = exports.fontSizeDefault = "1rem"; // 14px

var fontSizeSmall = exports.fontSizeSmall = "0.875rem"; // 12px

var fontSizeMinimum = exports.fontSizeMinimum = "0.75rem";
var fontSizeBase = exports.fontSizeBase = "16px";
var letterSpacingDefault = exports.letterSpacingDefault = "0.0125em";
var letterSpacingCap = exports.letterSpacingCap = "0.05em";
var lineHeightDefault = exports.lineHeightDefault = "1.5";
var lineHeightTight = exports.lineHeightTight = "1.25";
var lineHeightSmallFont = exports.lineHeightSmallFont = "1.125rem";
var fontSmoothing = exports.fontSmoothing = "antialiased";
var fontWeightThin = exports.fontWeightThin = "100";
var fontWeightExtraLight = exports.fontWeightExtraLight = "200";
var fontWeightLight = exports.fontWeightLight = "300";
var fontWeightBook = exports.fontWeightBook = "400";
var fontWeightRegular = exports.fontWeightRegular = "500";
var fontWeightMedium = exports.fontWeightMedium = "600";
var fontWeightBold = exports.fontWeightBold = "700";
var fontWeightBlack = exports.fontWeightBlack = "800";